import { Plus } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import * as React from "react";

export interface FilterCategory {
  key: string;
  label: string;
  icon?: React.ReactNode;
}

interface AddFilterMenuProps {
  categories: FilterCategory[];
  onSelect: (key: string) => void;
  /** When true, render as icon-only button */
  iconOnly?: boolean;
}

export function AddFilterMenu({ categories, onSelect, iconOnly }: AddFilterMenuProps) {
  const [open, setOpen] = React.useState(false);

  if (categories.length === 0) return null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        {iconOnly ? (
          <Button variant="outline" size="icon" className="h-9 w-9">
            <Plus className="h-4 w-4" />
          </Button>
        ) : (
          <Button variant="outline" className="h-9 text-sm">
            <Plus className="h-4 w-4 mr-1" />
            Add filter
          </Button>
        )}
      </PopoverTrigger>
      <PopoverContent className="w-48 p-1" align="start" sideOffset={6}>
        <p className="px-2 py-1.5 text-sm font-semibold text-muted-foreground">New filter</p>
        {categories.map((cat) => (
          <button
            key={cat.key}
            className="flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-sm hover:bg-accent transition-colors text-left"
            onClick={() => {
              onSelect(cat.key);
              setOpen(false);
            }}
          >
            {cat.icon && <span className="text-muted-foreground">{cat.icon}</span>}
            {cat.label}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
